import { getCountry, getWithDotComByCountry, getManualByCountry } from '../utils';

const country = getCountry();
const withCom = getWithDotComByCountry(country);
const withWww = window.location.href.indexOf('www') > -1 ? 'www.' : '';
const docHost = `https://help.qa.neogig${withCom}${country}`;
const linkManual = getManualByCountry(country, docHost);

export const env = {
    NODE_ENV: 'development',
    NEOGIG_CLIENT_ID: 'neogig_qa',
    NEODASH_CLIENT_ID: 'neodash_qa',
    MAPBOX_KEY: `pk.eyJ1IjoibmVvY29tc2VydmljZSIsImEiOiJjbWRodGl3ZjkwNWd5MmpxMXMzM2RubWlxIn0.cVfKHNfwS3HgtJn4rj1vPg`,
    GOOGLE_MAPS_API_KEY: 'AIzaSyCA0PnZss05UqLCBCHW11hK1FLULtrfYO0',
    CARTO_KEY: 'cb1_28bg_1_0356ced9998003b244e01e82',
    URL: {
        NEOGIG_HOST: `https://${withWww}qa.neogig${withCom}${country}`,
        NEODASH_HOST: `https://neodash.qa.neogig${withCom}${country}`,
        API_HOST: `https://neogig-api.qa.neogig${withCom}${country}/api/v1`,
        MANUAL_URL: linkManual,
        IDENTITY_SERVER_URL: `https://identity-server.qa.neogig${withCom}${country}`,
        CTRL_PANEL_API: `https://cp-api.qa.neogig${withCom}${country}`,
    }
};



// WEBPACK FOOTER //
// ./src/config/qa.env.js